<template>
  <v-menu
    v-model="menu1"
    :close-on-content-click="false"
    :nudge-right="40"
    offset-y
    class="imd-sm-input-date-picker no-transition"
    min-width="293px">
    <template v-slot:activator="{ on }">
      <v-text-field
        v-bind="{
          ...$attrs,
          value: value_cp
        }"
        v-on="{
          ...on,
          ...$listeners,
          input: e => emit(value_cp = e, 1),
        }"

        v-mask="'####-##-##'"

        label=""
        append-icon="event"
        class="imd-sm-input-date imd-sm-input"
        outlined
      ></v-text-field>
    </template>
    <v-date-picker
      no-title
      :value="parseDate(value_cp) || T.now('YYYY-MM-DD')"
      @input="e => {
        menu1 = false;
        value_cp = parseDate(e);
        emit(e, 2);
      }"
      :day-format="date => parseInt(date.split('-')[2])"
      locale="ko-kr" />
  </v-menu>
<!--

  :day-format="date => parseInt(date.split('-')[2])"

  이 코드로 인해서 "1일" "2일" -> "1" "2" 이렇게 숫자만 나오게 된다.
  말 그대로 day(일) 포멧이다.

 -->
      <!-- :day-format="date => parseInt(date.split('-')[2])" -->
</template>

<style>
/* div.imd-sm-input-date div.v-input__icon > i.v-icon { color: red; } */
</style>

<script>

const VALUE_FORMAT = 'YYYYMMDD'

const isDebug = false
import InputSet from './mixin/input-set';
export default {
  inheritAttrs: false,
  mixins: [ InputSet ],
  props: ['value'],
  data () {
    return {
      value_cp : null,
      menu1: false,
      sendEmitValue: null,
    }
  },
  computed: {
    v_id() {
      return this.$vnode.data.model && 'input-'+this.$vnode.data.model.expression || 'v'
    }
  },
  watch: {
    value(n, p) {
      isDebug && console.log("[i-input-date2] watch : 수신 new =", n, " prev ", p, 'this.value = ', this.value, 'this.value_cp = ', this.value_cp, 'this.sendEmitValue = ', this.sendEmitValue)
      if (this.value === undefined) { // clear()시 호출됨.
        isDebug && console.log(`[${ this.v_id }] watch() value undefined emit return`);
        this.$emit("input", "")
        return
      }

      if (!n && this.value_cp) { // 값이 초기화됨
        isDebug && console.log("[i-input-date2] watch : 초기화")
        this.value_cp = null
        return
      }

      if (this.sendEmitValue == n) {
        isDebug && console.log("[i-input-date2] watch : 보낸값을 그대로 수신함. 아무것도 안함.")
        this.sendEmitValue = null
        return
      }

      this.value_cp = this.parseDate(n)
      isDebug && console.log("[i-input-date2] watch : 내부변수 설정 : " + this.value_cp)
    }
  },
  created () {
    if (this.value !== undefined)
      this.value_cp = this.parseDate(this.value)
  },
  beforeUpdate() {
    if (this.value === undefined) { // 최초 생성시 1 이 안되는 경우 이걸로 해야 됨. 둘다 필수
      this.$emit("input", "")
    }
  },
  methods: {
    parseDate(d) {
      if (!d) return "";
      const v  = this.$moment(d, VALUE_FORMAT).format('YYYY-MM-DD')
      return v == "Invalid date" ? "" : v
    },
    emit(e,c) {
      const emitValue = e && e.replace(/-/g, '') || ''
      isDebug && console.log("[i-input-date2] emit case ", c, " event = ", e, ' emitValue = ', emitValue, 'this.value = ', this.value, 'this.value_cp = ', this.value_cp, 'this.sendEmitValue = ', this.sendEmitValue)

      if ((!emitValue && !this.value) || emitValue == this.value) {
        isDebug && console.log("[i-input-date2] emit 값이 동일하다. emit 안함")
        return
      }

      isDebug && console.log("[i-input-date2] emit 실행!  : '" + emitValue + "'")
      this.$emit('input', this.sendEmitValue = emitValue)
    }
  },
}

</script>
